import { Component, Input } from "@angular/core";
import { ForgeLabelValueModule } from "@tylertech/forge-angular";

@Component({
    selector: "labeled-field",
    imports: [
        ForgeLabelValueModule
    ],
    templateUrl: "./labeledField.tmpl.html",
    styleUrls: [
        "./labeledField.component.scss"
    ]
})
export class LabeledFieldComponent
{
    @Input() readonly label: string;
}
